import axios from 'axios'
import APIS from '@/util/apis'
import xinliceshiApp from '@/util/xinliceshiApp'

export function getUserKey ({channelId, userId = '', openId = '', unionId = '', avatar = '', nickname = ''}) {
  return axios.get('/api/user/refreshUser', {params: {userId, channelId, openId, unionId, avatar, nickname}})
}

export function getVipinfo ({channelId, userKey = ''}) {
  return axios.get('/lx/vip/getVipInfo', {params: {userKey, channelId}})
}

export async function getUser ({channelId, token, userId = '', openId = '', unionId = ''}) {
  let {data: msiteUser} = await axios.get(`//m${APIS.env}.xinli001.com/ajax/get-user-header`,{params:{token}})
  let muserId, mopenId, munionId
  let avatar = msiteUser.data.user ? msiteUser.data.user.avatar : ''
  let nickname = msiteUser.data.user ? msiteUser.data.user.nickname : ''

  if (msiteUser.data.user && msiteUser.data.user.id) {
    muserId = msiteUser.data.user.id
    mopenId = msiteUser.data.user.wx_openid
    munionId = msiteUser.data.user.wx_unionid
    xinliceshiApp.relaodWebView()
  } else {
    muserId = userId
    xinliceshiApp.removeReloadTag()
  }

  if (muserId) {
    console.log('refreshUserParams', {userId: muserId, channelId, openId: mopenId, unionId: munionId, nickname, avatar});
    let {data: userKeyRes} = await axios.get('/api/user/refreshUser', {
      params: {
        userId: muserId,
        channelId,
        openId: mopenId,
        unionId: munionId,
        nickname,
        avatar
      }
    })
    console.log('refreshUser', userKeyRes);
    return userKeyRes
  } else {
    console.log('---平台没有登录---')
    return {
      userId: '',
      openId: '',
      unionId: '',
      userKey: ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/entry/getUserKey.js